import { TranslateLoader } from '@ngx-translate/core';
import { HttpModule, Http, Response } from '@angular/http';
import { Subject, Observable } from 'rxjs';

export class TranslateHttpLoader implements TranslateLoader {
  public static obs = new Subject();

  constructor(
    private http: Http,
    private url: string,
    private partials: string[]
  ) {}

  /**
     * Gets the translations from the server
     * @param lang
     * @returns {any}
     */
  public getTranslation(lang: string): any {
    let obsList = this.partials.map(x => {
      return this.http
        .get(`${this.url}${x}/${lang}`)
        .map((res: Response) => res.json());
    });

    return Observable.forkJoin(...obsList).map(results => {
      TranslateHttpLoader.obs.next();
      return results.reduce((prev, next) => Object.assign({}, prev, next));
    });
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/Common/translate-http-loader.ts
 **/